import React, { useEffect, useRef } from "react";
import { Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import gsap from "utils/gsap";

const DataTable = ({
  columns,
  data,
  renderActions,
  onRowClick,
  emptyMessage = "No data found",
  showSerialNumber = true,
  hover = true,
  responsive = true,
  t = (key) => key, // translation function
  className = "",
}) => {
  const tbodyRef = useRef(null);

  // Render cell content based on column configuration
  const renderCell = (column, item, index) => {
    const value = column.accessor ? column.accessor(item) : item[column.key];

    // Custom render function
    if (column.render) {
      return column.render(value, item, index);
    }

    // Link rendering
    if (column.link) {
      const href =
        typeof column.link === "function" ? column.link(item) : column.link;
      return <Link to={href}>{value || "-"}</Link>;
    }

    // Default rendering with className support
    if (column.className) {
      return <div className={column.className}>{value || "-"}</div>;
    }

    return value || "-";
  };

  useEffect(() => {
    if (!tbodyRef.current) return;

    const rows = tbodyRef.current.querySelectorAll("tr");

    gsap.fromTo(
      rows,
      { opacity: 0 },
      {
        opacity: 1,
        duration: 0.2,
        ease: "none",
        stagger: 0.04,
        clearProps: "opacity",
      }
    );
  }, [data]);

  return (
    <div
      className={`common_table_style ${className} ${
        !showSerialNumber && "no_s_no"
      }`}
    >
      <Table hover={hover} responsive={responsive}>
        <thead className="t_head">
          <tr>
            {showSerialNumber && <th style={{ width: 70 }}>{t("S.No")}</th>}
            {columns.map((column, idx) => (
              <th
                key={idx}
                style={column.style}
                className={column.headerClassName}
              >
                {t(column.header)}
              </th>
            ))}
            {renderActions && <th>{t("Actions")}</th>}
          </tr>
        </thead>

        <tbody ref={tbodyRef}>
          {data?.length > 0 ? (
            data.map((item, index) => (
              <tr
                key={item._id || index}
                onClick={() => onRowClick?.(item)}
                style={onRowClick ? { cursor: "pointer" } : {}}
              >
                {showSerialNumber && <td>{index + 1}</td>}

                {columns.map((column, colIdx) => (
                  <td key={colIdx} className={column.cellClassName}>
                    {renderCell(column, item, index)}
                  </td>
                ))}

                {renderActions && (
                  <td onClick={(event) => event.stopPropagation()}>
                    <div className="actions">{renderActions(item, index)}</div>
                  </td>
                )}
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan={
                  columns.length +
                  (showSerialNumber ? 1 : 0) +
                  (renderActions ? 1 : 0)
                }
                className="text-center py-3 text-muted"
              >
                {t(emptyMessage)}
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default DataTable;
